import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  constructor(@Inject(DOCUMENT) private document: any) { }

  ngOnInit() {
    if (environment.name !== 'development') {
      this.document.location.href = environment.notFoundUrl;
    }
  }
}
